import React from 'react';

import { getIconPath, getImagePath } from 'src/utils';
import * as styles from '../styles';

const pngLogoMap = {
  APC: 'apc-logo.png',
  'Collect+': 'collect-plus-logo.png',
  Doddle: 'doddle-logo.png',
  DPD: 'dpd-logo.png',
  ipostparcels: 'ipostparcels-logo.png',
  'Royal Mail': 'royal-mail-logo.png',
  'UK Mail': 'uk-mail-logo.png',
  UPS: 'ups-logo.png',
};

const svgLogoMap = {
  DHL: 'dhl-logo.svg',
  DX: 'dx-logo.svg',
  Evri: 'evri-logo.svg',
  'FedEx UK': 'fedex-express-logo.svg',
  Hermes: 'evri-logo.svg',
  myHermes: 'evri-logo.svg',
  Interlink: 'interlink-logo.svg',
  'Other Provider': 'other-provider-logo.svg',
  Parcelforce: 'parcel-force-logo.svg',
  TNT: 'tnt-logo.svg',
  Tuffnells: 'tuffnells-logo.svg',
  Whistl: 'whistl-logo.svg',
  Yodel: 'yodel-logo.svg',
};

const getDeliveryProviderLogo = (deliveryProviderName: string) => {
  if (pngLogoMap[deliveryProviderName]) {
    return getImagePath(pngLogoMap[deliveryProviderName]);
  }
  if (svgLogoMap[deliveryProviderName]) {
    return getIconPath(svgLogoMap[deliveryProviderName]);
  }
  return null;
};

export default function DeliveryProviderLogo({ name }: { name: string }) {
  const logo = getDeliveryProviderLogo(name);
  const altText = name !== 'Other Provider' ? name : 'Delivery provider not specified';

  return logo ? (
    <span css={styles.deliveryProviderLogo}>
      <img src={logo} width="36" alt={altText} />
    </span>
  ) : null;
}
